import { isSourcingActive, type SourcingRunStatus } from "./types/sourcing-run";

/** What the "Stelle schließen" dialog should say (#19). Mirrors the backend:
 * no closing during a search, and the owner is emailed only when someone
 * else closes the job. */
export interface CloseJobPlan {
  /** The latest search isn't known yet; don't offer the close until it is. */
  checking: boolean;
  blocked: boolean;
  notifiesOwner: boolean;
}

export function closeJobPlan(input: {
  ownerId: string;
  actorId: string;
  /** `undefined` while it's loading, `null` when the job never had a search. */
  latestRunStatus: SourcingRunStatus | null | undefined;
}): CloseJobPlan {
  return {
    checking: input.latestRunStatus === undefined,
    blocked: input.latestRunStatus != null && isSourcingActive(input.latestRunStatus),
    notifiesOwner: input.actorId !== input.ownerId,
  };
}
